import {
    Autocomplete,
    Box,
    Button,
    Container,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Snackbar,
    TextField,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import countries from "../../../data/countries";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Navbar";
import LinksFooter from "../home/LinksFooter";
import Footer from "../home/Footer";
import Cookies from "js-cookie";
import guestIcon from "../../../images/guest.png"
import { useDropzone } from 'react-dropzone';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';

function Ads() {
    const navigate = useNavigate();
    // const {email}=useParams()
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [file, setFile] = useState();
    const [snackbarOpenError, setSnackbarOpenError] = useState(false);
    const { t } = useTranslation();
    const lang = Cookies.get("i18next") || "en";
    const [Image, setImage] = useState();
    const [fileImageName, setFileImageName] = useState('');

    const {
        register,
        control,
        formState: { errors },
        handleSubmit,
    } = useForm({
        defaultValues: {
            advertiserName: "",
            email: "",
            phoneNumber: "",
            titleArabic: "",
            titleEnglish: "",
            descriptionArabic: "",
            descriptionEnglish: "",
            country: "",
        },
    });

    const { getRootProps: getRootPropsImage, getInputProps: getInputPropsImage } = useDropzone({
        onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles),  // عند اختيار الصورة
        accept: 'image/*'  // تحديد أن نوع الملف المسموح به هو الصور
    });
    // هذه دالة التعامل مع صورة
    const handleFileUpload = (files) => {
        if (files && files[0]) {
            setFileImageName(files[0].name);  // تخزين اسم الصورة
            setImage(files[0]);

        }
    };
    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append("image", Image);
        formData.append("lang", lang);
        for (const key in data) {
            if (key !== "image") { // تجنب إضافة الصورة مرتين
                formData.append(key, data[key]);
            }
        }
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_KEY}api/v1/advertisement`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                setSnackbarOpen(true);
                setTimeout(() => (
                    navigate('/')
                ), 3000)
            } else {
                setSnackbarOpenError(true);
            }
        } catch (error) {
            setSnackbarOpenError(true);
        }
    };


    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
        setSnackbarOpenError(false);
    };

    return (
        <>
            <Navbar>
                <>
                    <Container className="mt-24 mb-10  ">
                        <Paper
                            sx={{
                                padding: "50px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "start",
                            }}
                        >
                            <Box sx={{
                                margin: "auto",
                                width: "100%",
                            }}>
                                <Typography
                                    sx={{
                                        fontSize: "24px",
                                        textAlign: "center",
                                        fontWeight: "700",
                                        marginBottom: "30px",
                                        color: "#3B82F6FC"
                                    }}
                                >
                                    {t("Add Your Ad Here")}
                                </Typography>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Box sx={{ marginBottom: "30px" }}>
                                        <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", color: "#3B82F6FC", fontWeight: "700" }}>
                                            {t("Advertiser Name")}
                                        </InputLabel>
                                        <Controller
                                            name="advertiserName"
                                            control={control}
                                            render={({ field }) => <TextField type="text" style={{
                                                border: "2px solid #3B82F6FC",
                                                borderRadius: "5px",
                                            }} {...field} fullWidth />}
                                            {...register("advertiserName", {
                                                required: "Advertiser Name is required",
                                            })}
                                        />
                                        {errors.advertiserName && (
                                            <Typography
                                                color="error"
                                                role="alert"
                                                sx={{ fontSize: "13px", marginTop: "6px" }}
                                            >
                                                {t("required")}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ marginBottom: "30px" }}>
                                        <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", color: "#3B82F6FC", fontWeight: "700" }}>
                                            {t("Advertiser Email")}
                                        </InputLabel>
                                        <Controller
                                            name="email"
                                            control={control}
                                            render={({ field }) => <TextField type="email" style={{
                                                border: "2px solid #3B82F6FC",
                                                borderRadius: "5px",
                                            }} {...field} fullWidth />}
                                            {...register("email", {
                                                required: "Advertiser Email is required",
                                            })}
                                        />
                                        {errors.advertiserName && (
                                            <Typography
                                                color="error"
                                                role="alert"
                                                sx={{ fontSize: "13px", marginTop: "6px" }}
                                            >
                                                {t("required")}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ marginBottom: "30px" }}>
                                        <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", color: "#3B82F6FC", fontWeight: "700" }}>
                                            {t("title Arabic")}
                                        </InputLabel>
                                        <Controller
                                            name="titleArabic"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField type="text" style={{
                                                    border: "2px solid #3B82F6FC",
                                                    borderRadius: "5px",
                                                }} {...field} fullWidth />
                                            )}
                                            {...register("titleArabic", {
                                                required: "title Arabic is required",
                                            })}
                                        />
                                        {errors.titleArabic?.type === "required" && (
                                            <Typography
                                                color="error"
                                                role="alert"
                                                sx={{ fontSize: "13px", marginTop: "6px" }}
                                            >
                                                {t("required")}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ marginBottom: "30px" }}>
                                        <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", color: "#3B82F6FC", fontWeight: "700" }}>
                                            {t("title English")}
                                        </InputLabel>
                                        <Controller
                                            name="titleEnglish"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField type="text" style={{
                                                    border: "2px solid #3B82F6FC",
                                                    borderRadius: "5px",
                                                }} {...field} fullWidth />
                                            )}
                                            {...register("titleEnglish", {
                                                required: "title English is required",
                                            })}
                                        />
                                        {errors.titleEnglish?.type === "required" && (
                                            <Typography
                                                color="error"
                                                role="alert"
                                                sx={{ fontSize: "13px", marginTop: "6px" }}
                                            >
                                                {t("required")}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ marginBottom: "30px" }}>
                                        <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", color: "#3B82F6FC", fontWeight: "700" }}>
                                            {t("description Arabic")}
                                        </InputLabel>
                                        <Controller
                                            name="descriptionArabic"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField style={{
                                                    border: "2px solid #3B82F6FC",
                                                    borderRadius: "5px",
                                                }} {...field} rows={3} multiline fullWidth />
                                            )}
                                            {...register("descriptionArabic", {
                                                required: "description Arabic Address is required",
                                            })}
                                        />
                                        {errors.descriptionArabic?.type === "required" && (
                                            <Typography
                                                color="error"
                                                role="alert"
                                                sx={{ fontSize: "13px", marginTop: "6px" }}
                                            >
                                                {t("required")}
                                            </Typography>
                                        )}

                                    </Box>
                                    <Box sx={{ marginBottom: "30px" }}>
                                        <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", color: "#3B82F6FC", fontWeight: "700" }}>
                                            {t("description English")}
                                        </InputLabel>
                                        <Controller
                                            name="descriptionEnglish"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField style={{
                                                    border: "2px solid #3B82F6FC",
                                                    borderRadius: "7px",
                                                }} {...field} rows={3} multiline fullWidth />
                                            )}
                                            {...register("descriptionEnglish", {
                                                required: "description English Address is required",
                                            })}
                                        />
                                        {errors.descriptionEnglish?.type === "required" && (
                                            <Typography
                                                color="error"
                                                role="alert"
                                                sx={{ fontSize: "13px", marginTop: "6px" }}
                                            >
                                                {t("required")}
                                            </Typography>
                                        )}
                                    </Box>
                                    <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", color: "#3B82F6FC", fontWeight: "700" }}>
                                        {t("phone")}
                                    </InputLabel>
                                    <Box sx={{ marginBottom: "26px", direction: "rtl" }}>
                                        <Controller
                                            name="phoneNumber"
                                            control={control}
                                            render={({ field }) => <PhoneInput style={{
                                                border: "2px solid #3B82F6FC",
                                                borderRadius: "5px",
                                            }}{...field} />}
                                            {...register("phoneNumber", {
                                                required: "phone Number is required",
                                            })}
                                        />
                                        {errors.phoneNumber?.type === "required" && (
                                            <Typography
                                                color="error"
                                                role="alert"
                                                sx={{ fontSize: "13px", marginTop: "6px" }}
                                            >
                                                {t("required")}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ marginBottom: "26px" }}>
                                        <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", color: "#3B82F6FC", fontWeight: "700" }}>{t('country')}</InputLabel>
                                        <Controller
                                            name="country"
                                            control={control}
                                            rules={{ required: t('required') }}
                                            render={({ field: { onChange, value } }) => (
                                                <Autocomplete
                                                    options={countries}
                                                    getOptionLabel={(option) => lang === "en" ? option.name_en : option.name_ar}
                                                    isOptionEqualToValue={(option, val) => option.code === val}
                                                    onChange={(e, newValue) => onChange(newValue ? newValue.code : "")}
                                                    value={countries.find((c) => c.code === value) || null}
                                                    renderOption={(props, option) => (
                                                        <li {...props} key={option.code}>
                                                            <img src={`https://flagcdn.com/w40/${option.code}.png`} width={25} style={{ marginLeft: 8 }} alt="" />
                                                            {lang === "en" ? option.name_en : option.name_ar}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => <TextField {...params} style={{
                                                        border: "2px solid #3B82F6FC",
                                                        borderRadius: "5px",
                                                    }} fullWidth />}
                                                />
                                            )}
                                        />
                                        {errors.location && (
                                            <Typography color="error" sx={{ fontSize: "13px", marginTop: "6px" }}>{t('required')}</Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ marginBottom: "18px" }}>
                                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px", fontWeight: 'bold', color: '#333' }}>
                                            {t("ImageGest")}
                                        </InputLabel>
                                        <div {...getRootPropsImage()} style={{
                                            border: '2px dashed #3B82F6FC',
                                            padding: '20px',
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            borderRadius: '4px'
                                        }}>
                                            <input {...getInputPropsImage()} />
                                            <CloudUploadIcon sx={{ fontSize: "30px", color: "#3B82F6FC" }} />
                                            <Typography sx={{ fontSize: "14px", color: "#3B82F6FC", marginTop: "8px" }}>
                                                {t("ImageGest")}
                                            </Typography>
                                        </div>
                                        {fileImageName && (
                                            <Typography sx={{ marginTop: "10px", fontSize: "17px", color: "red", textAlign: "center" }}>
                                                {t("selected Image")}: {fileImageName}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        type="submit"
                                        sx={{ backgroundColor: "#3B82F6FC", fontWeight: "700" }}
                                    >
                                        {t("Add Ad Here")}
                                    </Button>
                                </form>
                            </Box>
                            <Box sx={{
                                display: { md: "block", xs: "none" }
                            }}>
                                <img src={guestIcon} alt={guestIcon} width={1500} />
                            </Box>
                        </Paper>
                    </Container>
                    <Snackbar
                        open={snackbarOpen}
                        autoHideDuration={4000}
                        onClose={handleCloseSnackbar}
                        message={t("Ad submitted successfully!")}
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    />
                    <Snackbar
                        open={snackbarOpenError}
                        autoHideDuration={4000}
                        onClose={handleCloseSnackbar}
                        message={t("Failed to post ad!!")}
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    />
                </>
                <LinksFooter />
                <Footer />
            </Navbar>
        </>
    );
}

export default Ads;